import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchAllSafetySuggestions } from '../../../api/v4';
import history from '../../../history';
import { getAccessLevel, getMyUserId } from '../../../selectors/users';
import Header from '../../../components/Header';
import HeaderAndFooter from '../../../components/HeaderAndFooter';
import List from '../../../components/List';
import TypeSelection from '../../../components/TypeSelection';

function SafetySuggestionsList() {
  const accessLevel = useSelector(getAccessLevel);
  const [suggestionsList, setSuggestionsList] = useState([]);
  const [listType, setListType] = useState(
    accessLevel >= 500 ? 'All Suggestions' : 'My Suggestions'
  );
  const uId = useSelector(getMyUserId);

  useEffect(() => {
    fetchAllSafetySuggestions().then(setSuggestionsList);
  }, []);

  const header = (
    <Header
      section="Safety Suggestions"
      rightButtons={{
        text: 'Create Safety Suggestion',
        onClick: () => history.push('/app/safetySuggestions'),
        color: 'blue'
      }}
    />
  );

  const columns = [
    { key: 'safetySuggestionId', label: 'Suggestion Number' },
    {
      key: 'stage',
      label: 'Status',
      enum: ['Open', 'Under Review', 'Closed']
    },
    { key: 'createdAt', label: 'Date Received', datatype: 'date' },
    { key: 'dateClosed', label: 'Date Closed', datatype: 'date' }
  ];

  const listTypeFilter =
    listType === 'My Suggestions'
      ? suggestionsList?.filter(s => s.creatorId === uId)
      : suggestionsList;

  return (
    <HeaderAndFooter Header={header}>
      {accessLevel >= 500 && (
        <TypeSelection
          selectedArray={['All Suggestions', 'My Suggestions']}
          selected={listType}
          onClick={setListType}
        />
      )}

      <List
        data={listTypeFilter}
        settings={columns}
        dataIsHash
        saveKey="SafetySuggestionList"
        name="SafetySuggestionList"
        getRowId={r => r._id}
        rowClick={row => history.push(`/app/safetySuggestions/${row._id}`)}
      />
    </HeaderAndFooter>
  );
}

export default SafetySuggestionsList;
